interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
  light?: boolean;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = 'left',
  light = false,
}: SectionHeadingProps) {
  const isCenter = align === 'center';

  return (
    <div className={`${isCenter ? 'text-center mx-auto max-w-3xl' : 'max-w-3xl'}`}>
      {eyebrow && (
        <div className={`flex items-center gap-2 ${isCenter ? 'justify-center' : ''}`}>
          <span className="h-px w-6 bg-accent-500" />
          <span className="text-xs md:text-sm font-label tracking-[0.2em] text-accent-600 uppercase">
            {eyebrow}
          </span>
        </div>
      )}
      <h2
        className={`mt-3 font-heading text-2xl md:text-4xl font-bold leading-tight ${
          light ? 'text-background-50' : 'text-foreground-950'
        }`}
      >
        {title}
      </h2>
      {desc && (
        <p
          className={`mt-3 md:mt-4 text-sm md:text-base leading-relaxed ${
            light ? 'text-background-200' : 'text-foreground-600'
          }`}
        >
          {desc}
        </p>
      )}
    </div>
  );
}